import Slide from './Slide'

export default Slide
